"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var useStyles = function useStyles(props) {
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    fontFamily = _useContext.fontFamily,
    direction = _useContext.direction;
  var ccAudiencePickerStyle = (0, _react.useMemo)(function () {
    var ccAudiencePicker = (0, _css.css)({
      direction: direction,
      fontFamily: fontFamily,
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
    });
    return {
      ccAudiencePicker: ccAudiencePicker
    };
  }, [direction, fontFamily]);
  return {
    'cc-AudiencePicker': ccAudiencePickerStyle.ccAudiencePicker
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;